import React from "react";

import { useAppDispatch, useAppSelector } from "../../Store/Hooks";
import { resetGuidancePreview } from "../../Store/Reducers/GuidanceSlice";
import { getTodayCadence } from "../../Utils/Guidance/guidanceCadence";

const DAY_NAMES = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

/**
 * Admin-only, client-side-only "Preview as day" simulation banner
 * (Admin > Org Settings > Cadence Schedule) — never persisted, never
 * visible to other users, resets on reload. Matches the prototype's
 * yellow simulation banner exactly.
 */
const GuidancePreviewBanner: React.FC = () => {
  const dispatch = useAppDispatch();
  const {
    previewDayOverride,
    previewFirstWeekOverride,
    previewFirstQuarterOverride,
    cadenceSchedule,
  } = useAppSelector(state => state.guidance);

  const isPreviewing =
    previewDayOverride !== null ||
    previewFirstWeekOverride ||
    previewFirstQuarterOverride;
  if (!isPreviewing) return null;

  const cadence = getTodayCadence(
    new Date(),
    cadenceSchedule,
    previewDayOverride,
    previewFirstWeekOverride,
    previewFirstQuarterOverride
  );

  const dayLabel =
    previewDayOverride !== null ? DAY_NAMES[previewDayOverride] : "today";
  const calendarFlags = [
    previewFirstWeekOverride && "1st week of month",
    previewFirstQuarterOverride && "1st week of quarter",
  ].filter(Boolean);

  return (
    <div className="sticky top-0 z-50 flex items-center gap-2 bg-amber-50 border-b border-amber-300 px-4 py-1.5 text-xs font-semibold text-amber-800">
      <span>
        ⚠ Simulating: {dayLabel}
        {calendarFlags.length > 0 && ` (${calendarFlags.join(", ")})`} →{" "}
        {cadence} playbook
      </span>
      <button
        type="button"
        onClick={() => dispatch(resetGuidancePreview())}
        className="border border-amber-400 rounded px-2 py-0.5 text-amber-800 hover:bg-amber-100"
      >
        Reset to today
      </button>
    </div>
  );
};

export default GuidancePreviewBanner;
